import { inject, Injectable } from '@angular/core';

import { HttpApiService } from '@core/http-legacy';

import { TellentAuthRequestData } from './tellent-auth-request-data';

@Injectable({ providedIn: 'root' })
export class TellentHttpAuthApiService extends HttpApiService {
  constructor() {
    super(inject(TellentAuthRequestData));
  }
}
